module.exports = __webpack_public_path__ + "static/media/READY_TO_SCAN_ITEMS.07fa3940.svg";